<template>
  <div
    class="km-skeleton"
    :class="css"
    :style="{ height: height }"
  >
    <template v-if="avatar">
      <skeleton-placeholder
        class="km-skeleton__avatar"
        :width="width"
        :loading="loading"
      />
      <skeleton-placeholder
        class="km-skeleton__title"
        :width="width"
        :loading="loading"
      />
      <skeleton-placeholder
        class="km-skeleton__label"
        :width="width"
        :loading="loading"
      />
    </template>

    <div class="km-skeleton__content-wrapper">
      <skeleton-placeholder
        v-for="n in contentCount"
        :key="n"
        class="km-skeleton__content"
        :data-content="n"
        :width="width"
        :loading="loading"
        :show-gutter="n === gutterIndex"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import SkeletonPlaceholder from './SkeletonPlaceholder'
import {
  padding,
  contentSize,
  contentGap,
  avatarSize,
  gapBetweenAvatarAndContent,
} from './constants'

export default {
  name: 'KSkeleton',
  components: {
    SkeletonPlaceholder,
  },
  props: {
    size: {
      type: Number,
      default: 4,
    },
    avatar: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      width: 0,
    }
  },
  computed: {
    gutterIndex() {
      return _.random(2, this.size - 1)
    },
    css() {
      return {
        'km-skeleton--has-avatar': this.avatar,
        'km-skeleton--loading': this.loading,
      }
    },
    loadingStyle() {
      if (!this.loading) {
        return
      }
      return {
        backgroundSize: `${this.width * 2}px ${avatarSize}px`,
      }
    },
    contentCount() {
      return this.size > 20 ? 20 : this.size
    },
    height() {
      let height = padding * 2 + contentSize * this.size + contentGap * (this.size - 1)
      if (this.avatar) {
        height += avatarSize + gapBetweenAvatarAndContent
      }
      return height + 'px'
    },
  },
  mounted() {
    this.width = this.$el.getBoundingClientRect().width - padding * 2
  },
  methods: {},
}
</script>
